// App.js
import React from 'react';
import Header from './components/Header/Header';
import styles from './App.module.scss';
import BrandSlider from "./components/BrandSlider/BrandSlider";
import WatchList from "./components/WatchList/WatchPurchaseGrid";
import Footer from "./components/Footer/Footer";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import BrandDetail from "./components/BrandDetail/BrandDetail";
import FloatingContactButton from "./components/FloatingContactButton/FloatingContactButton";
import WatchPurchaseGrid2 from "./components/WatchList/WatchPurchaseGrid2";
import WatchPurchaseGrid3 from "./components/WatchList/WatchPurchaseGrid3";
import WatchPurchaseGrid4 from "./components/WatchList/WatchPurchaseGrid4";
import WatchPurchaseGrid5 from "./components/WatchList/WatchPurchaseGrid5";
import WatchPurchaseGrid6 from "./components/WatchList/WatchPurchaseGrid6";
import WatchPurchaseGrid7 from "./components/WatchList/WatchPurchaseGrid7";
import WatchPurchaseGrid8 from "./components/WatchList/WatchPurchaseGrid8";
import NotFound from "./components/NotFound/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Routes className={styles.app}>
        <Route path={'/'} element={
          <>
            <Header />
            <BrandSlider />
            <WatchList />
            <WatchPurchaseGrid2 />
            <WatchPurchaseGrid3 />
            <WatchPurchaseGrid4 />
            <WatchPurchaseGrid5 />
            <WatchPurchaseGrid6 />
            <WatchPurchaseGrid7 />
            <WatchPurchaseGrid8 />
            <Footer />
            <FloatingContactButton />
          </>
        }/>
        <Route path={'/brands/:brand'} element={
          <>
            <Header />
            <BrandSlider />
            <BrandDetail />
            <Footer />
            <FloatingContactButton />
          </>
        }/>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;